"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapOldColor = void 0;
const mapOldColor = (color, palette) => {
  switch (color) {
    case 'Black':
      return palette.common.black;
    case 'DarkGrey':
      return palette.grey[900];
    case 'White':
      return palette.common.white;
    case 'Brown':
      return palette.brown[300];
    case 'Green':
      return palette.secondary.main;
    case 'Grey':
      return palette.grey[900];
    default:
      return palette.default.light;
  }
};
exports.mapOldColor = mapOldColor;
